import React from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Button, Modal } from 'semantic-ui-react';
import css from './PatientInfo.less';

const PatientInfo = ({ data, id }) => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
  };
  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon
        className={css.customModal}
        size="tiny"
      >
        <Modal.Header>Patient Information</Modal.Header>
        <Modal.Content className={css.modalContent}>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Full name as per NRIC/FIN</div>
            <div className={css.itemBody}>{data?.properties?.fullName}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Nationality</div>
            <div className={css.itemBody}>{data?.properties?.nationality}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>NRIC</div>
            <div className={css.itemBody}>{data?.properties?.nric}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Passport Number</div>
            <div className={css.itemBody}>{data?.properties?.passportNo}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Gender</div>
            <div className={css.itemBody}>{data?.properties?.gender}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Date of birth</div>
            <div className={css.itemBody}>{data?.properties?.dateOfBirth}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Email</div>
            <div className={css.itemBody}>{data?.properties?.email}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>Phone</div>
            <div className={css.itemBody}>{data?.properties?.phone}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>COVID-19 ART Kit Brand</div>
            <div className={css.itemBody}>{data?.properties?.kitBrand}</div>
          </div>
          <div className={css.itemContent}>
            <div className={css.itemTitle}>ART Batch/lot Number</div>
            <div className={css.itemBody}>{data?.properties?.batchNumber}</div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}
            className={css.submitBtn}
          >
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default PatientInfo;
